import { ADD_AVATARS, AddAvatarsActionType, REMOVE_AVATARS, RemoveAvatarsActionType } from "./types";
import { createAction } from "@reduxjs/toolkit";

export const addAvatars = createAction<AddAvatarsActionType["payload"], typeof ADD_AVATARS>(ADD_AVATARS);
export const removeAvatar = createAction<RemoveAvatarsActionType["payload"], typeof REMOVE_AVATARS>(REMOVE_AVATARS);
